import React, { useEffect, useMemo } from "react";
import MemberPartnerDashboardWrapper from "../../../layout/wrapper/MemberPartnerDashboardWrapper";
import styles from "../../../styles/pages/user/memberpartner/memberpartner-analytics.module.scss";
import {
  Box,
  Button,
  List,
  ListItem,
  Menu,
  MenuItem,
  Stack,
  Typography,
  alpha,
  styled,
} from "@mui/material";
import graphAnalyticsDashboard from "../../../public/assets/images/graphAnalyticsDashboard.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AnalyticSubmissionIcon from "../../../ui/Icons/AnalyticSubmissionIcon";
import ApproveIconGreen from "../../../ui/Icons/ApproveIconGreen";
import RejectIcon from "../../../public/assets/icons/RejectIcon";
import BreakdownAnalyticsTableRight from "../../../components/BreakdownAnalyticsTable/BreakdownAnalyticsTableRight";
import RejectedVideoIcon from "../../../public/assets/icons/RejectedVideoIcon";
import BreakdownAnalyticsTable from "../../../components/BreakdownAnalyticsTable/BreakdownAnalyticsTable";
import BreakdownAnalyticsTableLeft from "../../../components/BreakdownAnalyticsTable/BreakdownAnalyticsTable";
import "react-perfect-scrollbar/dist/css/styles.css";
import ApiLoader from "../../../components/Loaders/ApiLoader";
import PerfectScrollbar from "react-perfect-scrollbar";
import useFetch, { usePost } from "../../../hooks/api/useFetch";
import ContentBuyerGraph from "../../../components/ContentBuyerGraph/ContentBuyerGraph";
import MemberPartnerGraph from "../../../components/Member_Partner_Graph/MemberPartnerGraph";
import CustomSelectTwo from "../../../components/CustomSelectTwo/CustomSelectTwo";
import { useState } from "react";
import { useRef } from "react";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: "auto",
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "&.MuiButtonBase-root": {
        color: "#000",
        fontSize: "14px",
      },
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const MemberPartnerAnalytics = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    console.log(event);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  /************************************/

  const [anchorElTable, setAnchorElTable] = React.useState(null);
  const openTable = Boolean(anchorElTable);
  console.log("openTable", anchorElTable);
  const handleClickTable = (event) => {
    setAnchorElTable(event.currentTarget);
  };
  const handleCloseTable = () => {
    setAnchorElTable(null);
  };
  const [inputValue, setInputValue] = useState("This year");

  const handelInputValue = (e) => {
    setInputValue(e.target.innerText);
    console.log("eeeeeeeeeeeee", e.target.innerText);
  };
  // partnerDataLoad
  const {
    data: submissionsData,
    isLoading: managerLoading,
    isSuccess: managerSubmissionsIsSuccess,
    isFetching,
  } = usePost(["manager-partner-submissions"], "member_partner/submissions");

  console.log("submissionsData", submissionsData?.data?.data?.submissions);
  // partnerDataLoad

  // analytics
  const {
    data: expenseData,
    isLoading: expenseLoading,
    isSuccess: expenseSubmissionsIsSuccess,
    isFetching: expenseFetching,
  } = usePost(
    ["manager-partner-expense", inputValue],
    `member_partner/expense-breakdown`,
    {
      year: inputValue,
    }
  );

  /***************************************** ContentBuyer Chart section Start*****************************************/

  const [year, setYear] = React.useState(`${new Date().getFullYear()}`);

  const handleChangeYear = (event) => {
    setYear(event.target.value);
  };
  const yearList = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const startingYear = 2021;
    const yearArray = [];

    for (let year = currentYear; year >= startingYear; year--) {
      yearArray.push(year);
    }

    return yearArray.filter((item) => item !== year); // Exclude the selected year
  }, [new Date().getFullYear(), year]);

  const yearList1 = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const startingYear = 2021;
    const yearArray = [];

    for (let year = currentYear; year >= startingYear; year--) {
      yearArray.push(year);
    }

    return yearArray.filter((item) => item !== year); // Exclude the selected year
  }, [new Date().getFullYear(), year]);

  const { data: memberPartnerGraphData, isLoading: memberPartnerLoading } =
    useFetch(
      ["member_partner_graph", year],
      `/member_partner/graph?year=${year}`
    );
  const [yearValue, setYearValue] = React.useState("");
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();
  const [years, setYears] = React.useState([]);
  const handleChange1 = (event) => {
    setYearValue(event.target.value);
  };
  const monthIndices = {
    January: 0,
    February: 1,
    March: 2,
    April: 3,
    May: 4,
    June: 5,
    July: 6,
    August: 7,
    September: 8,
    October: 9,
    November: 10,
    December: 11,
  };
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setYearValue(currentYear);

    const yearList = Array.from(
      { length: currentYear - 2020 },
      (_, index) => currentYear - index
    );

    setYears(yearList);
  }, []);

  /***************************************** ContentBuyer Chart section End*****************************************/

  return (
    <MemberPartnerDashboardWrapper>
      <ApiLoader loading={expenseLoading || managerLoading} />
      <Box className={styles.memberPartnerAnalytic}>
        <PerfectScrollbar className={styles.analyticsTableScroll}>
          <Box className={styles.submissionBreakdown}>
            <Box className={styles.graph}>
              <Box className={styles.graphHeading}>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  flexWrap={"wrap"}
                  justifyContent={"space-between"}
                  className={styles.formcontrolSearchHeader}
                >
                  <Typography variant="h4">Submissions breakdown</Typography>

                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    <CustomSelectTwo
                      value={year}
                      onChange={handleChangeYear}
                      displayEmpty
                    >
                      {/* <MenuItem value={""}></MenuItem>e */}
                      {yearList.map((_y) => (
                        <MenuItem key={_y} value={_y}>
                          {_y == new Date().getFullYear() ? "This year" : _y}
                          {/* {_y} */}
                        </MenuItem>
                      ))}
                    </CustomSelectTwo>
                    <div
                      style={{
                        position: "absolute",
                        right: "20px",
                        top: "28%",
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </div>
                  </div>
                </Stack>
              </Box>

              <Box className={styles.graphImg}>
                <MemberPartnerGraph
                  data={memberPartnerGraphData?.data}
                  loading={memberPartnerLoading}
                  total={memberPartnerGraphData?.data}
                />
              </Box>
            </Box>

            <Box className={styles.graphColorBox}>
              <List>
                <ListItem>
                  <Box className={styles.graphColorBoxIcon}>
                    <AnalyticSubmissionIcon />
                  </Box>
                  <Box className={styles.graphColorBoxTxt}>
                    <Typography variant="body1">
                      All Submissions{" "}
                      <Typography variant="caption">
                        {submissionsData?.data?.data?.submissions
                          ?.submitted_videos
                          ? submissionsData?.data?.data?.submissions
                              ?.submitted_videos
                          : "_"}
                      </Typography>
                    </Typography>
                  </Box>
                </ListItem>

                <ListItem className={styles.approveBox}>
                  <Box className={styles.graphColorBoxIcon}>
                    <ApproveIconGreen />
                  </Box>
                  <Box className={styles.graphColorBoxTxt}>
                    <Typography variant="body1">
                      Approved Videos{" "}
                      <Typography variant="caption">
                        {" "}
                        {submissionsData?.data?.data?.submissions?.approved
                          ? submissionsData?.data?.data?.submissions?.approved
                          : "_"}
                      </Typography>
                    </Typography>
                  </Box>
                </ListItem>

                <ListItem className={styles.rejectedBox}>
                  <Box className={styles.graphColorBoxIcon}>
                    <RejectedVideoIcon />
                  </Box>
                  <Box className={styles.graphColorBoxTxt}>
                    <Typography variant="body1">
                      Rejected Videos{" "}
                      <Typography variant="caption">
                        {" "}
                        {submissionsData?.data?.data?.submissions?.rejected
                          ? submissionsData?.data?.data?.submissions?.rejected
                          : "_"}
                      </Typography>
                    </Typography>
                  </Box>
                </ListItem>
              </List>
            </Box>
          </Box>

          <Box className={styles.earningBreakdown}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              className={styles.earningBreakdownStack}
            >
              <Box className={styles.earningBreakdownBox}>
                <Button>January - June</Button>
                <Box>
                  <BreakdownAnalyticsTableLeft
                    expenseData={expenseData}
                    expenseLoading={expenseLoading}
                    expenseSubmissionsIsSuccess={expenseSubmissionsIsSuccess}
                    approved={
                      submissionsData?.data?.data?.submissions?.approved
                    }
                  />
                </Box>
              </Box>

              <Box className={styles.earningBreakdownBox}>
                <Button>July - December</Button>
                <Box>
                  <BreakdownAnalyticsTableRight
                    expenseData={expenseData}
                    expenseLoading={expenseLoading}
                    expenseSubmissionsIsSuccess={expenseSubmissionsIsSuccess}
                    approved={
                      submissionsData?.data?.data?.submissions?.approved
                    }
                  />
                </Box>
              </Box>
            </Stack>

            <Typography variant="h4" className={styles.breakDownH4}>
              Earnings breakdown
            </Typography>

            <Box className={styles.seeAllDropDown}>
              <Box className={styles.formcontrolSearch}>
                <Button
                  id="demo-customized-button"
                  aria-controls={openTable ? "demo-customized-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openTable ? "true" : undefined}
                  variant="contained"
                  disableElevation
                  onClick={handleClickTable}
                  endIcon={<KeyboardArrowDownIcon />}
                >
                  {inputValue}
                </Button>
                <StyledMenu
                  id="demo-customized-menu"
                  MenuListProps={{
                    "aria-labelledby": "demo-customized-button",
                  }}
                  anchorEl={anchorElTable}
                  open={openTable}
                  onClose={handleCloseTable}
                >
                  {/* <MenuItem value="">This year</MenuItem> */}
                  {years.map((year) => (
                    <MenuItem
                      onClick={(e) => {
                        handelInputValue(e);
                        handleCloseTable();
                      }}
                      key={year}
                      value={year}
                    >
                      {year == new Date().getFullYear() ? "this year" : year}
                    </MenuItem>
                  ))}
                  {/* <MenuItem
                    onClick={(e) => {
                      handleCloseTable();
                      handelInputValue(e);
                    }}
                    disableRipple
                  >
                    Edit
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      handleCloseTable();
                      handelInputValue(e);
                    }}
                    disableRipple
                  >
                    Duplicate
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      handleCloseTable();
                      handelInputValue(e);
                    }}
                    disableRipple
                  >
                    Archive
                  </MenuItem> */}
                </StyledMenu>
              </Box>
            </Box>
          </Box>
        </PerfectScrollbar>
      </Box>
    </MemberPartnerDashboardWrapper>
  );
};

export default MemberPartnerAnalytics;
